export default "__VITE_ASSET__C52AslvA__"